/**
 * Battery Status API Detector
 * Detects suspicious battery patterns common in headless browsers
 */

export interface BatteryResult {
  charging?: boolean;
  level?: number;
  chargingTime?: number;
  dischargingTime?: number;
}

interface BatteryManager {
  charging: boolean;
  chargingTime: number;
  dischargingTime: number;
  level: number;
}

export async function detectBatteryStatus(): Promise<BatteryResult> {
  try {
    const getBattery = (navigator as Navigator & { getBattery?: () => Promise<BatteryManager> }).getBattery;

    if (!getBattery) {
      return {};
    }

    const battery = await getBattery.call(navigator);

    return {
      charging: battery.charging,
      level: battery.level,
      chargingTime: isFinite(battery.chargingTime) ? battery.chargingTime : undefined,
      dischargingTime: isFinite(battery.dischargingTime) ? battery.dischargingTime : undefined,
    };
  } catch (error) {
    return {};
  }
}
